export default function preventPageScrolling() {
  let position = 0;

  const preventScroll = function preventScroll() {
    position = window.scrollY;

    document.body.style.top = `-${position}px`;

    document.body.classList.add(
      'q-body--prevent-scroll',
      'q-body--force-scrollbar-y',
    );
  };

  const allowScroll = function allowScroll() {
    document.body.classList.remove(
      'q-body--prevent-scroll',
      'q-body--force-scrollbar-y',
    );

    document.body.style.top = '';

    window.scrollTo({ top: position });

    position = 0;
  };

  return {
    preventScroll,
    allowScroll,
  };
}
